const initialReducerState = {
  color: '',
  clarity: '',
  shape: '',
  rap: '',
  carat: '',
  activeInputName: 'carat',
  price: '0',
  priceTotal: '0',
  priceInitial: '0',
  priceTotalInitial: '0'
}

const errorMessage = "Couldn't save filter"

export {
  initialReducerState,
  errorMessage
}
